<template>
  <div class="realName">
    <div class="personal-box comWidth">
      <CenterNav/>
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">
          <div class="right-shiming right-address">
            <div class="information">
              根據海關規定，購買跨境商品需要辦理清關相關手續，請您配合進行實名認證，以確保您購買的商品順利通過海關檢查。
              <span>（澳門極草承諾您提供的個人實名信息只用於購買本（公司）網站產品之用，不作他途使用，其他任何人均無法查看。）</span>
            </div>
            <table class="table table-condensed shiming-table">
              <thead>
              <tr>
                <th><p>姓名</p></th>
                <th><p>身份證號</p></th>
                <th><p>身份證照片</p></th>
                <th><p>審核狀態</p></th>
                <th><p>操作</p></th>
              </tr>
              </thead>
              <tbody v-if="msgData.id">
              <tr>
                <td>
                  <p>{{msgData.real_name}}</p>
                </td>
                <td>
                  <p>{{msgData.obtainCard}}</p>
                </td>
                <td>
                  <p>{{msgData.uploadStatus}}</p>
                </td>
                <td>
                  <p v-if="msgData.audit_status == 0">審核中</p>
                  <p v-if="msgData.audit_status == 1">審核通過</p>
                  <p v-if="msgData.audit_status == -1">審核失敗</p>
                </td>
                <td>
                  <el-button type="text" @click="seeMsg">查看</el-button>
                   <!--<el-button type="text" v-if="msgData.audit_status == -1">修改</el-button>-->
                </td>
              </tr>
              </tbody>
            </table>

            <!--审核失败原因-->
            <div class="fail" v-if="msgData.audit_status == -1">
              <span>備註 ：</span>
              <span>{{note}}</span>
            </div>

            <div class="form-horizontal" v-if="msgData.audit_status != 1">
              <div class="form-group">
                <label class="col-sm-2 control-label"><span>*</span>真實姓名</label>
                <div class="col-sm-9">
                  <input v-model="userName" id="userName" type="text" class="form-control"  placeholder="請填寫您的真實姓名">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"><span>*</span>身份證號</label>
                <div class="col-sm-9 datep">
                  <input type="text" v-model="idCard" class="form-control" id="idCard" placeholder="請填寫姓名對應的身份證號">
                </div>
              </div>
              <div class="form-group Idcard-imgbox">
                <label class="col-sm-2 control-label">上传照片</label>
                <div class="idBox">

                  <div class="col-sm-5">
                    <el-upload
                      class="avatar-uploader"
                      :action="IMG"
                      :show-file-list="false"
                      :data="{type:'id_card'}"
                      :headers="{'Accept':'application/prs.verygrass.v1+json','Authorization':token}"
                      name="image"
                      :on-success="handleAvatarSuccess_z"
                      :before-upload="beforeAvatarUpload">
                      <img v-if="imageUrl_z" :src="imageUrl_z" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>

                    <p class="shi">示例</p>
                    <img src="../../../assets/icon/idcard-imgshili.jpg" alt="" id='code_img_z'>
                    <input type="file" name="z" >
                  </div>

                  <div class="col-sm-5">
                    <el-upload
                      class="avatar-uploader"
                      :action="IMG"
                      :data="{type:'id_card'}"
                      :headers="{'Accept':'application/prs.verygrass.v1+json','Authorization':token}"
                      name="image"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess_f"
                      :before-upload="beforeAvatarUpload">
                      <img v-if="imageUrl_f" :src="imageUrl_f" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>

                    <p class="shi">示例</p>
                    <img src="../../../assets/icon/idcard-imgshili2.jpg" alt="" id='code_img_f'>
                    <input type="file" >
                  </div>
                </div>
              </div>
              <div class="annotation-word">
                註： <br>
                1.需上傳清晰的身份證正面、反面共2張照片 <br>
                2.照片不超過5mb，支持格式jpg，jpeg，png
              </div>
              <div class="annotation-word">

                <input type="hidden" name="code_z" id="code_z" value=""/>
                <input type="hidden" name="code_f" id="code_f" value=""/>
              </div>
              <button @click="verificationC" class="btn" v-if="msgData.audit_status == -1">修改</button>
              <button @click="certification" class="btn" v-else>認證</button>
            </div>
            <div>
              <h5 style="margin-bottom: 6px;
    padding-bottom: 14px;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #ddd;">常見問題：</h5>
              <p style="font-size: 12px;line-height: 24px;">
                1、為什麼要進行實名認證？<br>
                根據海關規定，購買跨境商品需進行實名認證，用於個人物品出入境申報。為確保您購買的商品能夠順利辦理相關手續，請配合提供實名信息。
              </p>
              <p style="font-size: 12px;line-height: 24px;">
                2、實名認證必須要上傳身份證照片嗎？<br>
                根據海關要求，部分跨境商品清關時需提供收貨人實名信息對身份證影印件進行校驗。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  //api
  import {authentication , authenticationMsg , authenticationModify} from '@/api/authentication';
  import {getToken} from '@/utils/auts';


  export default {
    name: 'RealName',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'實名認證',
        imageUrl_z: '',
        imageUrl_f: '',

        /*person msg*/
        //真实姓名
        userName:'',
        //身份证
        idCard:'',
        regIdCard : /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
       //获取token
        token:'Bearer ' + getToken(),
        //身份证正反面
        front_photo:'',
        backside_photo:'',
        //备注
        note:'',
        //实名认证信息
        msgData:{
            real_name:'',
            obtainCard:'',
            audit_status:null,
            examine:'',
            uploadStatus :'已上傳',
            masgState:false
          },
        IMG:this.IMG
      }
    },
    methods:{
      handleAvatarSuccess_z(res, file) {
        this.imageUrl_z = URL.createObjectURL(file.raw);
        if(res){
          this.front_photo = res.path;
        }
      },
      handleAvatarSuccess_f(res, file) {
        this.imageUrl_f = URL.createObjectURL(file.raw);
        if(res){
          this.backside_photo = res.path;
        }
      },
      beforeAvatarUpload(file) {
/*
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.warning('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.warning('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;*/
        const isLt2M = file.size / 1024 / 1024 < 2;
        const ext = file.type.split('/')[1].toLowerCase()
        if (ext !== 'jpg' && ext !== 'png' && ext !== 'jpeg' && ext !== 'gif' && ext !== 'bpm') {
          this.$message.warning('图片必须是jpg, jpeg, png, gif, bpm类型的文件!')
          return false
        }else {
          return true
        }
        if (!isLt2M) {
          this.$message.warning('上传头像图片大小不能超过 2MB!');
        }

      },

      /*点击认证*/
      certification(){
          if(this.msgData.audit_status == 0){
            this.$message.warning('正在稽核中');
          }else if(this.msgData.audit_status == 1){
            this.$message.warning('稽核已通過，請不要重複提交');
          }else {
            if((this.userName).trim() === ''){
              this.$message.warning('請輸入真實姓名');
            }else if(!this.regIdCard.test(this.idCard)){
              this.$message.warning('請輸入正確的身份證號碼');
            }
        /*    else if(this.front_photo === ''){
              this.$message.warning('請上傳身份證正面照');
            }
            else if(this.backside_photo === ''){
              this.$message.warning('請上傳身份證背面照');
            }*/
            else {
              var obj = {
                real_name : this.userName ,
                id_card : this.idCard ,
                front_photo:this.front_photo,
                backside_photo : this.backside_photo};
              authentication(obj).then(res =>{
                this.$message.success('上傳成功 ，等待稽核');
                this.authenticationMsgs()
              })
            }
          }
      },

      /*如果验证失败，修改的数据*/
      verificationC(){
        if((this.userName).trim() === ''){
          this.$message.warning('請輸入真實姓名');
        }else if(!this.regIdCard.test(this.idCard)){
          this.$message.warning('請輸入正確的身份證號碼');
        }
    /*    else if(this.front_photo === ''){
          this.$message.warning('請上傳身份證正面照');
        }
        else if(this.backside_photo === ''){
          this.$message.warning('請上傳身份證背面照');
        }*/
        else {
          var obj = {
            userVerification:this.msgData.id,
            real_name : this.userName ,
            id_card : this.idCard ,
            front_photo:this.front_photo,
            backside_photo : this.backside_photo};
          authenticationModify(obj).then(res =>{
            this.$message.success('修改成功 ，等待稽核');
            this.authenticationMsgs()
          })
        }
      },


      /*获取用户实名认证信息*/
      authenticationMsgs(){
        //获取
        authenticationMsg().then(res =>{
          this.msgData.real_name = res.data.real_name;
          this.msgData.id = res.data.id;
          if(this.msgData.real_name){
            this.msgData.masgState = true
          }else if(!this.msgData.real_name){
            this.msgData.masgState = false
          }
          //身份证照判断
          this.msgData.uploadStatus = (res.data.front_photo || res.data.backside_photo)
          ? '已上傳' : '未上傳';
          this.msgData.obtainCard = (res.data.id_card).replace(((res.data.id_card)).substring(6,14),'********');
          this.msgData.audit_status = res.data.audit_status;
          this.note = res.data.note;
        })
      },
      // 查看信息
      seeMsg(){
        var str = `
        <p class="text">澳門極草承諾您提供的個人實名信息只用於購買本（公司）網站產品之用，不作他途使用，其他任何人均無法查看。</p>
        <p class="text">实名者：${this.msgData.real_name}</p>
        <p class="text">身份证：${this.msgData.obtainCard}</p>
        <p class="bottom">为保护您的个人隐私，历史已上传的身份證號已做加密处理，无法再次查看</p>
        `
          this.$alert(str, '实名认证', {
          dangerouslyUseHTMLString: true,
            lockScroll: false,
        });
      },
      // 删除认证信息
      deleteMsg() {
        this.$confirm('此操作将删除该实名认证信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          lockScroll:false
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }

    },
    created(){
      this.authenticationMsgs();
      window.scrollTo(0,0)
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../../css/realName.less";

</style>



// WEBPACK FOOTER //
// src/pages/personalPage/accountSettingPage/RealName.vue